VjsAdmin.PlatformDashboard = (function () {
    const platformId = $('#usage-chart').attr('data-platform-id');

    let chartsData = null;
    const chartOptions = {
        height: 400,
        width: $('#usage-chart').width(),
        legend: 'none',
        lineWidth: 0.25,
        chartArea: { width: '90%', height: '65%' },
        animation: {
            startup: true,
            duration: 400,
        },
        bar: {
            groupWidth: '95%',
        },
        hAxis: {
            format: 'MMM y',
            gridlines: {
                color: '#949494',
            },
        },
        vAxis: {
            format: '#,###',
        },
        colors: ['#4285f4'],
        areaOpacity: 0.7,
    };

    let loginsCalendarData = null;

    const init = function () {
        // Load the Visualization API and the corechart package.
        google.charts.load('current', {
            packages: ['corechart', 'calendar'],
        });

        // Set a callback to run when the Google Visualization API is loaded.
        google.charts.setOnLoadCallback(loadChartData);

        $('#platform-activity-overview-container').on('click', '.js-chart-type', function () {
            const type = $(this).attr('data-chart-type');
            $(this).addClass('active').siblings('.js-chart-type').removeClass('active');
            if (type === 'time') {
                buildTimeChart();
            } else {
                buildVisitChart();
            }
        });

        function loadChartData() {
            $.ajax({
                url: Slim.Router.pathFor('platforms.activity_overview.json', {
                    platform_id: platformId,
                }),
                dataType: 'json',
                method: 'POST',
                async: true,
            }).done((responseData, textStatus, jqXHR) => {
                chartsData = jqXHR.responseJSON.data;
                buildVisitChart();
            });

            $.ajax({
                url: Slim.Router.pathFor('platforms.logins_calendar.json', {
                    platform_id: platformId,
                }),
                dataType: 'json',
                method: 'POST',
                async: true,
            }).done((responseData, textStatus, jqXHR) => {
                loginsCalendarData = jqXHR.responseJSON;
                buildLoginsCalendar();
            });
        }

        function buildVisitChart() {
            const d = new google.visualization.DataTable();
            d.addColumn('date', 'Date');
            d.addColumn('number', 'Site Visits');

            for (let i = 0; i < chartsData.length; i++) {
                d.addRow([new Date(Date.parse(`${chartsData[i].year}-${chartsData[i].month}-1`)), parseFloat(chartsData[i].site_visits)]);
            }

            // draw chart
            const chart = new google.visualization.ColumnChart($('#usage-chart').get(0));
            chart.draw(d, chartOptions);
        }

        function buildTimeChart() {
            const d = new google.visualization.DataTable();
            d.addColumn('date', 'Date');
            d.addColumn('number', 'Time Spent Hours');

            for (let i = 0; i < chartsData.length; i++) {
                d.addRow([
                    new Date(Date.parse(`${chartsData[i].year}-${chartsData[i].month}-1`)),
                    parseFloat(chartsData[i].time_spent / 60 / 60),
                ]);
            }

            // draw chart
            const chart = new google.visualization.ColumnChart($('#usage-chart').get(0));
            chart.draw(d, chartOptions);
        }

        function buildLoginsCalendar() {
            const dataTable = new google.visualization.DataTable();
            dataTable.addColumn({ type: 'date', id: 'Date' });
            dataTable.addColumn({ type: 'number', id: 'Number of Events' });
            dataTable.addColumn({
                type: 'string',
                role: 'tooltip',
                p: { html: true },
            });

            const rows = [];
            $.each(loginsCalendarData.data, (year, months) => {
                $.each(months, (month, days) => {
                    $.each(days, (day, value) => {
                        const date = new Date(parseInt(year), parseInt(month - 1), parseInt(day));
                        const momentDate = moment(`${year}${month}${day}`, 'YYYYMMDD').tz(moment.tz.guess());

                        let time = value.time_spent;
                        const hours = Math.floor(time / 3600);
                        time -= hours * 3600;
                        const minutes = Math.floor(time / 60);
                        const timeString = (hours > 0 ? `${hours} hour${hours === 1 ? '' : 's'}` : '')
                            + (minutes > 0 ? `${(hours > 0 ? ',<br>' : '') + minutes} minute${minutes === 1 ? '' : 's'}` : '');

                        const tooltip = '<table class="calendar-tooltip">'
                            + `<tr><th colspan="2">${momentDate.format('LL')}</th></tr>`
                            + `<tr><th><strong>Users:</strong></th><td>${value.users}</td></tr>`
                            + `<tr><th><strong>Logins:</strong></th><td>${value.logins}</td></tr>`
                            + `<tr><th><strong>Time Spent:</strong></th><td>${timeString}</td></tr>`
                            + '</table>';
                        const row = [date, value.time_spent / 60 / 60, tooltip];
                        rows.push(row);
                    });
                });
            });
            dataTable.addRows(rows);

            const chart = new google.visualization.Calendar(document.getElementById('logins_calendar'));
            const parentWidth = Math.round($('#logins_calendar').outerWidth());
            const cellSize = (parentWidth - 118) / 53;

            const options = {
                title: 'Hours Spent on Site',
                tooltip: { isHtml: true },
                width: parentWidth,
                calendar: { cellSize },
                colorAxis: { minValue: 0, colors: ['#FFFFFF', '#23527c'] },
                noDataPattern: {
                    backgroundColor: '#fafafa',
                    color: '#f8e8e8',
                },
            };

            chart.draw(dataTable, options);
        }

        $(window).on(
            'resize',
            VjsAdmin.debounce(() => {
                const type = $('#platform-activity-overview-container .js-chart-type.active').attr('data-chart-type');

                if (type === 'time') {
                    buildTimeChart();
                } else {
                    buildVisitChart();
                }

                buildLoginsCalendar();
            }, 250),
        );
    };

    return {
        init,
    };
}());
